import { AssetReference } from '@opallabs/cassini'
import { kuiperClassNames } from '@opallabs/kuiper'
import { ModularCarousel } from '@opallabs/periodic/src/ModularCarousel'
import { doNothing } from '../../helpers/functions/doNothing'
import { useValidModules } from '../../helpers/hooks'
import { Module, OnAddSectionProps, OnDragDropProps } from '../../helpers/types'
import { MobileSingle } from './display'
import { styles } from './styles'

type FacebookStoryProps = {
  accountImage: AssetReference
  accountName: string
  collabEnabled?: boolean
  collabAccount?: string
  fbStoryAllowReplies: boolean
  fbStoryAllowSharing: boolean
  isExpanded: boolean
  isPresenting: boolean
  modules: Module[]
  onAddSection?: (args: OnAddSectionProps) => void
  onDeleteSection?: () => void
  onDragDrop?: OnDragDropProps
  onExpandAsset?: () => void
  onRemoveAsset?: () => void
  onShowAssetPicker?: () => void
  readOnly: boolean
  updateSectionPostOption?: () => void
}

export const FacebookStory: React.FC<FacebookStoryProps> = ({
  accountImage,
  accountName,
  collabEnabled,
  collabAccount,
  fbStoryAllowReplies,
  fbStoryAllowSharing,
  isExpanded,
  isPresenting = false,
  modules = [],
  onAddSection,
  onDeleteSection,
  onDragDrop,
  onExpandAsset,
  onRemoveAsset,
  onShowAssetPicker,
  readOnly = false,
  updateSectionPostOption,
}) => {
  const validModules = useValidModules({
    modules,
    onAddSection: onAddSection ? onAddSection : doNothing,
    componentNames: ['fb_story_carousel_section'],
  })

  const availableModules = [
    {
      component: MobileSingle,
      componentName: 'fb_story_carousel_section',
      title: '',
    },
  ]

  return (
    <div
      css={styles.getBaseStyles(isExpanded)}
      className={kuiperClassNames(
        'facebook facebook-facebook-story facebook-mobile-single'
      )}
    >
      <ModularCarousel
        addComponentText="Add Story Section"
        allProps={{
          accountImage,
          accountName,
          collabEnabled,
          collabAccount,
          fbStoryAllowReplies,
          fbStoryAllowSharing,
        }}
        isExpanded={isExpanded}
        availableModules={availableModules}
        carouselWidth={375}
        modules={validModules}
        onDragDrop={onDragDrop ? onDragDrop : doNothing}
        onAddSection={onAddSection ? onAddSection : doNothing}
        onDeleteSection={onDeleteSection ? onDeleteSection : doNothing}
        onExpandAsset={onExpandAsset ? onExpandAsset : doNothing}
        onRemoveAsset={onRemoveAsset ? onRemoveAsset : doNothing}
        onShowAssetPicker={onShowAssetPicker ? onShowAssetPicker : doNothing}
        updateSectionPostOption={
          updateSectionPostOption ? updateSectionPostOption : doNothing
        }
        readOnly={readOnly}
        isPresenting={isPresenting}
      />
    </div>
  )
}
